// The ball pictures (frontend/scripts/balls/make-balls.mjs): a set in the style of each card deck, named as Mahjong's tile
// sets (options/assets.ts TILE_SETS: the retro deck classic_old is `retro`, an unknown deck gets it too). As the tiles, the
// balls follow the deck unless the player picked a set on the Themes window's Advanced tab (skin.ballType, owner
// 2026-11-03: "daj w opcjach zaawansowanych możliwość wyboru kulek"); a theme pick puts them back with its deck.
import { env } from '../env';
import { TILE_SET_NAMES, tileSetOf } from '../options/assets';

/** Raise it whenever make-balls.mjs draws the balls again (the pictures are kept a day; not `?v=`, which keeps a year). */
export const BALL_REVISION = '?b=2';

/** The sets in the order of the decks, for the Advanced tab's arrows. */
export const BALL_SET_NAMES = TILE_SET_NAMES;
export const ballSetOf = (deckType: string, ballType?: string): string => tileSetOf(deckType, ballType);
export const ballSrc = (set: string, colour: number): string => `${env.ss}images/balls/${set}/${colour}.svg${BALL_REVISION}`;
